
import React from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "@/components/Layout";
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingDashboard: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <section className="py-12 md:py-20 bg-gradient-to-b from-clay-50 to-background">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-10">
            <div className="flex items-center gap-4">
              <Skeleton className="h-12 w-12 rounded-full hidden md:block" />
              <div>
                <Skeleton className="h-6 w-24 mb-4" />
                <Skeleton className="h-8 w-64 mb-2" />
                <Skeleton className="h-4 w-48" />
              </div>
            </div>
            <div className="mt-4 md:mt-0 flex gap-4">
              <Skeleton className="h-10 w-32" />
              <Skeleton className="h-10 w-24" />
            </div>
          </div>
          
          <div className="flex items-center justify-center min-h-[30vh]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
              <p className="mt-4 text-muted-foreground">{t("dashboard.loading")}</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};
